import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';
import {
  SnackbarMessage,
  SnackbarProvider,
  useSnackbar as useSnackbarOriginal
} from 'notistack';
import { useCallback } from 'react';

export const useSnackbar = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbarOriginal();
  const enqueueSnackbarSuccess = useCallback(
    (message: SnackbarMessage) =>
      enqueueSnackbar(message, { variant: 'success' }),
    [enqueueSnackbar]
  );
  const enqueueSnackbarWarning = useCallback(
    (message: SnackbarMessage) =>
      enqueueSnackbar(message, { variant: 'warning' }),
    [enqueueSnackbar]
  );
  const enqueueSnackbarError = useCallback(
    (message: SnackbarMessage) =>
      enqueueSnackbar(message, { variant: 'error' }),
    [enqueueSnackbar]
  );
  return {
    enqueueSnackbar,
    closeSnackbar,
    enqueueSnackbarSuccess,
    enqueueSnackbarWarning,
    enqueueSnackbarError
  };
};

export const SnackbarProviderConfigured: React.FC = ({ children }) => {
  const theme = useTheme();
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
      classes={{
        variantSuccess: css({
          background: theme.custom.colors.green.w500,
          color: theme.custom.colors.green.w500
        }),
        variantError: css({
          background: theme.custom.colors.red.w500,
          color: theme.custom.colors.red.contrastText
        }),
        variantInfo: css({
          background: theme.custom.colors.blue.w500,
          color: theme.custom.colors.blue.contrastText
        }),
        variantWarning: css({
          background: theme.custom.colors.yellow.w500,
          color: theme.custom.colors.yellow.contrastText
        })
      }}
    >
      {children}
    </SnackbarProvider>
  );
};
